import {defineMessages} from 'react-intl';

export default defineMessages({
	countrySelectorTriggerTitle: {
		id: 'footer.country.selector.trigger.title',
		defaultMessage: 'Country:',
	},
	countrySelectorTitle: {
		id: 'footer.country.selector.title',
		defaultMessage: 'Select Country',
	},
	languageSelectorTriggerTitle: {
		id: 'footer.language.selector.trigger.title',
		defaultMessage: 'Language:',
	},
	languageSelectorTitle: {
		id: 'footer.language.selector.title',
		defaultMessage: 'Select Language',
	},
});
